import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../Infra/display-name";
import { StyledMenu, HXMenuTitle, HXMenuFooter } from "./HXMenu.styles";
export class HXMenuController {
    constructor(onOpen, onClose) {
        const [anchorEl, setAnchorEl] = React.useState(null);
        this.anchorEl = anchorEl;
        this.setAnchorEl = setAnchorEl;
        this.onOpen = onOpen;
        this.onClose = onClose;
    }
    openMenu(anchorAt) {
        var _a;
        this.setAnchorEl(anchorAt);
        (_a = this.onOpen) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    closeMenu() {
        var _a;
        this.setAnchorEl(null);
        (_a = this.onClose) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}
export const HXMenu = observer((props) => {
    var _a;
    const transformOrigin = props.position === "right"
        ? { horizontal: "left", vertical: "top" }
        : props.position === "above"
            ? { horizontal: "center", vertical: "bottom" }
            : { horizontal: "right", vertical: -1 * ((_a = props.verticalMenuOffset) !== null && _a !== void 0 ? _a : 0) };
    const anchorOrigin = props.position === "right"
        ? { horizontal: "right", vertical: "top" }
        : props.position === "above"
            ? { horizontal: "center", vertical: -8 }
            : { horizontal: "right", vertical: "bottom" };
    return (_jsxs(StyledMenu, { anchorEl: props.controller.anchorEl, id: "account-menu", open: !!props.controller.anchorEl, onClose: () => props.controller.closeMenu(), onClick: () => props.controller.closeMenu(), transformOrigin: transformOrigin, anchorOrigin: anchorOrigin, children: [props.title && _jsx(HXMenuTitle, { children: props.title }), props.children, props.footer && _jsx(HXMenuFooter, { children: props.footer })] }));
});
addDisplayName(HXMenu, "HXMenu");
